export const AUDIT_TYPES = {
  PRE_CONTRACT: 'general',
  UNDER_CONTRACT: 'under_contract',
};

export const AUDIT_COMPLETED_STATUSES = {
  COMPLETED_SUCCESS: 'completed_success',
  COMPLETED_ERRORS: 'completed_errors',
};

export const AUDIT_STATUSES = {
  NOT_STARTED: 'not_started',
  ...AUDIT_COMPLETED_STATUSES,
};
